import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import { Link } from 'react-router-dom';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import { MdModeEditOutline } from 'react-icons/md';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import uploadImage from '../helpers/uploadImage';
import { toast } from 'react-toastify';

const AdminCategoryList = ({ userType }) => {
    const [categoryProduct, setCategoryProduct] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingBrand, setEditingBrand] = useState(null);
    const [pic, setPic] = useState("");
    const [openFullScreenImage, setOpenFullScreenImage] = useState(false);
    const [fullScreenImage, setFullScreenImage] = useState("");
    const [confirmationVisible, setConfirmationVisible] = useState(false);
    const [brandToDelete, setBrandToDelete] = useState(null);
    

    const categoryLoading = new Array(13).fill(null);

    const fetchCategoryProduct = async (userType) => {
        try {
            setLoading(true);
            const response = await fetch(SummaryApi.getBrands.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userType: userType }),
            });

            const dataResponse = await response.json();
            setLoading(false);

            if (dataResponse.success) {
                setCategoryProduct(dataResponse.data);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handleEdit = (brand) => {
        setIsEditing(true);
        setEditingBrand(brand);
        setPic(brand?.pic)
        document.body.style.overflow = 'hidden'; 
    };

    const saveChanges = async () => {
        const updatedData = {
            pic: pic ,
            brandId:editingBrand?._id  
          };
        
          const response = await fetch(SummaryApi.updateBrand.url, {
            method: SummaryApi.updateBrand.method,
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(updatedData) 
          });
        
          const responseData = await response.json();
        
          if (responseData.success) {
             setIsEditing(false);
             setEditingBrand(null);
             setPic("");
             document.body.style.overflow = 'auto'; // Enable background scrolling again
             fetchCategoryProduct(userType);
         
          }
        
          if (responseData.error) {
            setLoading(false)
            toast.error("حدث خطأ أثناء تعديل صورة العلامة التجارية");
          }
       

       
    };

    const closeModal = () => {
        setIsEditing(false);
        document.body.style.overflow = 'auto'; // Enable background scrolling again
    };

    useEffect(() => {
        if (userType !== 'Medicine' && userType !== 'Cosmetic') {
            fetchCategoryProduct('Default');
        } else {
            fetchCategoryProduct(userType);
        }
    }, [userType]);

    const handleUploadPic = async (e) => {
        const file = e.target.files[0];
        const uploadImageCloudinary = await uploadImage(file);

          setPic(uploadImageCloudinary.url)

      };
    
      const handleDeletePic = async () => {
        setPic("");
      };

      const handleDeleteClick = (brand) => {
        setBrandToDelete(brand);
        setConfirmationVisible(true);
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(SummaryApi.deleteBrand.url, {
              method: SummaryApi.deleteBrand.method,
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: id,
              }),
            });

            const responseData = await response.json();

            if (responseData.success) {
                toast.success('تم حذف العلامة التجارية بنجاح');
                setConfirmationVisible(false);
                fetchCategoryProduct(userType);
            } else {
                toast.error('فشل حذف العلامة التجارية');
            }
        } catch (error) {
            toast.error('حدث فشل اثناء حذف العلامة التجارية');
        }
    };

    return (
        <div className="container mx-auto p-4" aria-hidden={isEditing ? "true" : "false"}>
            <div className="flex items-center gap-4 justify-between overflow-scroll scrollbar-none">
                {loading ? (
                    categoryLoading.map((el, index) => (
                        <div
                            className="h-16 w-16 md:w-20 md:h-20 rounded-full overflow-hidden bg-slate-200 animate-pulse"
                            key={'categoryLoading' + index}
                        ></div>
                    ))
                ) : (
                    categoryProduct.map((brand, index) => {
                        const categoryLink =
                            userType === 'Medicine'
                                ? `/admin-category-product?category=${brand?.brandName}`
                                : userType === 'Cosmetic'
                                ? `/admin-cosmetic-category-product?category=${brand?.brandName}`
                                : `/`;

                        return (
                            <div key={brand?.brandName} className="relative">
                                <Link to={categoryLink} className="cursor-pointer">
                                    <div className="w-24 h-24 md:w-30 md:h-30 rounded-full overflow-hidden p-4 bg-slate-200 flex items-center justify-center">
                                        <img
                                            src={brand?.pic || defaultImage}
                                            alt={brand?.brandName}
                                            className="h-full object-scale-down mix-blend-multiply hover:scale-125 transition-all"
                                        />
                                    </div>
                                    <p className="text-center text-sm md:text-base capitalize">{brand?.brandName}</p>
                                </Link>
                                {/* Edit Button */}
                                <button
                                    className="absolute top-2 right-2 bg-blue-500 text-white p-1 rounded-full hover:bg-blue-800"
                                    onClick={() => handleEdit(brand)}
                                >
                                   <MdModeEditOutline/>
                                </button>

                                <button
                                    className="absolute top-2 left-2 bg-red-600 hover:bg-red-800 rounded-full text-white"
                                    onClick={() => handleDeleteClick(brand)}
                                >
                                   <MdDelete size={24} /> 
                                </button>
                                
                            </div>
                        );
                    })
                )}
            </div>

            {confirmationVisible && (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
        <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative'>
            <h3 className='text-lg font-semibold mb-4'> ؟ {brandToDelete?.brandName} هل انت متاكد انك تريد حذف </h3>
            <div className='flex gap-4'>
                <button className='bg-red-500 text-white px-4 py-2 rounded' onClick={() => handleDelete(brandToDelete._id)}>نعم</button>
                <button className='bg-gray-300 px-4 py-2 rounded' onClick={() => setConfirmationVisible(false)}>لا</button>
            </div>
            {/* Optional Close Button */}
            <button 
                className='absolute top-2 right-2 text-gray-500 hover:text-gray-700'
                onClick={() => setConfirmationVisible(false)}
            >
                &times;
            </button>
        </div>
    </div>
)}

            {/* Modal for Editing */}
            {isEditing && (
                <div className="fixed inset-0 bg-gray-500 bg-opacity-90 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-lg relative">
                        <h2 className="text-xl mb-4">تعديل الصورة ل {editingBrand?.brandName}</h2>
                        <label htmlFor='categoryImage' className='mt-3'>صورة العلامة التجارية  :</label>
          <label htmlFor='uploadPicInput'>
            <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
              <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                <span className='text-4xl'><FaCloudUploadAlt /></span>
                <p className='text-sm'>قم برفع صورة العلامة التجارية </p>
                <input type='file' id='uploadPicInput' className='hidden' onChange={handleUploadPic} />
              </div>
            </div>
          </label>
          <div>
            {pic ? (
              <div className='flex items-center gap-2'>
                  <div className='relative group'>
                    <img
                      src={pic}
                      alt="صورة العلامة التجارية "
                      width={80}
                      height={80}
                      className='bg-slate-100 border cursor-pointer'
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(pic);
                      }}
                    />
                    <div
                      className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block cursor-pointer'
                      onClick={() => handleDeletePic()}
                    >
                      <MdDelete />
                    </div>
                  </div>
              </div>
            ) : (
              <p className='text-red-600 text-xs'>*من فضلك اضف صورة العلامة التجارية </p>
            )}
          </div>
                        <div className="mt-4">
                            <button
                                className="bg-blue-800 text-white px-4 py-2 rounded mr-2 hover:bg-blue-600"
                                onClick={saveChanges}
                            >
                                حفظ التعديلات
                            </button>
                            <button
                                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                                onClick={closeModal}
                            >
                                إلغاء
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminCategoryList;
